import React, { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import api from "@/lib/api";
import { Loader2, Phone, Calendar, MapPin } from "lucide-react";

const TIMELINE_PILL = {
  immediate: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "3-6_months": "bg-amber-50 text-amber-800 border-amber-200",
  exploring: "bg-gray-50 text-gray-700 border-gray-200",
};

export default function AdminLeads() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/leads");
        setRows(data.leads || []);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <DashboardShell>
      <div data-testid="admin-leads">
        <div className="overline text-sg-gold-deep">LEADS · PLATFORM-WIDE</div>
        <h1 className="font-display text-4xl text-sg-navy mt-1">All <span className="font-serif-italic text-sg-gold-deep">leads</span></h1>
        <p className="text-sg-mute mt-2">{rows.length} qualified or in-progress · last 2000</p>

        <div className="mt-6 bg-white border border-sg-line rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="bg-sg-cream-soft text-sg-mute text-xs uppercase">
                <tr>
                  <th className="text-left px-4 py-3">Created</th>
                  <th className="text-left px-4 py-3">Agent</th>
                  <th className="text-left px-4 py-3">Listing</th>
                  <th className="text-left px-4 py-3">Neighborhood</th>
                  <th className="text-left px-4 py-3">Budget</th>
                  <th className="text-left px-4 py-3">Timeline</th>
                  <th className="text-left px-4 py-3">Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={7} className="px-4 py-12 text-center text-sg-mute"><Loader2 className="w-4 h-4 animate-spin inline mr-2" />Loading…</td></tr>
                ) : rows.length === 0 ? (
                  <tr><td colSpan={7} className="px-4 py-12 text-center text-sg-mute">No leads yet.</td></tr>
                ) : (
                  rows.map((l) => (
                    <tr key={l.lead_id || l.session_id} className="border-t border-sg-line" data-testid={`admin-lead-row-${l.lead_id || l.session_id}`}>
                      <td className="px-4 py-3 text-xs font-mono">{l.created_at ? new Date(l.created_at).toLocaleString("en-IN") : "—"}</td>
                      <td className="px-4 py-3 text-xs">{l.agent_slug || l.agent_id || "—"}</td>
                      <td className="px-4 py-3 text-xs font-mono">{l.listing_id || "—"}</td>
                      <td className="px-4 py-3 text-xs">{l.neighborhood || "—"}</td>
                      <td className="px-4 py-3 text-xs">{l.budget || "—"}</td>
                      <td className="px-4 py-3 text-xs">
                        <span className={`px-2 py-0.5 rounded-full border text-[11px] ${TIMELINE_PILL[l.timeline] || "bg-gray-50 border-gray-200"}`}>
                          {l.timeline || "—"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-xs">{l.status || "—"}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </DashboardShell>
  );
}
